import { getFunctions, httpsCallable } from "firebase/functions";
import { app } from "../base";

// Client wrappers for the access-grant Cloud Functions callables. Region must
// match the deployed functions' default (us-central1), like stripeCheckout.js.
// Each returns the callable's `.data` payload. All writes to the `access`
// collection happen server-side in these callables (Firestore rules deny
// direct client writes).
const fns = () => getFunctions(app, "us-central1");

// Invite a member by email at a specific tier. Seats are accounted per tier;
// `tier` is required when the owner holds seats of more than one tier (the
// server defaults it when there's only one). The server validates the tier
// against the owner's available seats.
export const inviteMember = (email, tier) =>
  httpsCallable(fns(), "inviteMember")({ email, tier }).then((r) => r.data);

// Consume one of the owner's own seats for personal access at the given tier.
// The server writes the owner's own access/{email} seat at that tier, so it
// never auto-upgrades when they later buy a higher tier to delegate. `tier` is
// optional when the owner holds a single tier. Returns { ok, tier }.
export const claimOwnerSeat = (tier) =>
  httpsCallable(fns(), "claimOwnerSeat")({ tier }).then((r) => r.data);

// Remove a seat (claimed or unclaimed). Idempotent.
export const revokeMember = (email) =>
  httpsCallable(fns(), "revokeMember")({ email }).then((r) => r.data);

// Move an unclaimed seat to a new email atomically (server-side delete +
// re-invite in one transaction). The seat keeps its tier.
export const reassignMember = (from, to) =>
  httpsCallable(fns(), "reassignMember")({ from, to }).then((r) => r.data);

// Admin-only: grant self-expiring access. expiresAt is epoch milliseconds.
export const grantTemporaryAccess = (email, tier, expiresAt) =>
  httpsCallable(fns(), "grantTemporaryAccess")({ email, tier, expiresAt }).then(
    (r) => r.data,
  );

// Send the manual invite email via Maileroo (owner of the grant or admin only).
export const sendInviteEmail = (email) =>
  httpsCallable(fns(), "sendInviteEmail")({ email }).then((r) => r.data);
